import { getNetCheckUrl } from "@/config/config";
import { FocusSDK } from "@/utils";
import NetworkCheck from "@/utils/NetworkCheck";

export enum NetStatus {
  fail = 0,
  success = 1
}

const updateNetStatus = (status: NetStatus) => {
  const netServer = NetworkCheck.getInstance({
    url: getNetCheckUrl()
  });
  netServer.upadteNetResult({
    time: new Date().getTime(),
    state: status
  });
};

const updateNavigatorOnline = (status: boolean) => {
  const netServer = NetworkCheck.getInstance({
    url: getNetCheckUrl()
  });
  netServer.setStatus(status);
};

export { updateNavigatorOnline };

export default updateNetStatus;
